import { Trans, msg} from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { AppButton, ConfirmationModal, TextInput } from '@/UI';
import SmsIcon from '@/assets/icons/SmsIcon';
import { ReactComponent as PasswordIcon } from '@/assets/icons/password.svg';

import classes from './Login.module.css';
import useLogin from './useLogin';

const Login = () => {
    const { _ } = useLingui();

    const {
        errorState,
        onEmailChange,
        onPasswordChange,
        handleLogin,
        ModalProps,
        modalVisible,
        onCancelModal,
        value,
        loader,
    } = useLogin();

    const handleSubmit = event => {
        event.preventDefault();
        handleLogin();
    };

    return (
        <>
            <form
                onSubmit={handleSubmit}
                style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <div className={classes['inputWrapper']}>
                    <TextInput
                        name="email"
                        placeHolder={_(msg`Enter Your Email or Username`)}
                        label={_(msg`Email or Username`)}
                        onChange={onEmailChange}
                        value={value.email}
                        error={errorState.emailError}
                        icon={<SmsIcon fill={'var(--text-heading)'} />}
                    />
                    <TextInput
                        type="password"
                        name="pwd"
                        label={_(msg`Password`)}
                        placeHolder={_(msg`Enter Your Password`)}
                        value={value.password}
                        onChange={onPasswordChange}
                        error={errorState.passwordError}
                        icon={<PasswordIcon />}
                    />
                </div>
                <AppButton
                    title={<Trans>Login</Trans>}
                    type="submit"
                    loader={loader}
                    disable={loader}
                />
            </form>

            <ConfirmationModal
                visible={modalVisible}
                onCancel={onCancelModal}
                {...ModalProps}
            />
        </>
    );
};
export default Login;
